import {Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ModalComponent} from "@shared/components/modal/modal.component";
import {ModalConfig} from "@shared/components/modal/modal.interface";

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit {
  productId: string = '0245a348-f148-4a5d-abfe-ff282b3c4ecf'
  soId: string = '34c09069-7f7b-11ed-b6f4-16ddb2716acf'
  barcodeResult: BehaviorSubject<string> = new BehaviorSubject<string>("")
  modalInputManualConfig: ModalConfig = {
    modalTitle: "INPUT QR MANUAL",
    closeButtonLabel: "Close",
    dismissButtonLabel: "Submit"
  }
  @ViewChild('modalInputManual') private modalInputManual: ModalComponent;

  constructor() {
  }

  ngOnInit(): void {
  }

  updateScanner($event: any) {
    this.barcodeResult.next($event)
  }

  onOpenModal() {
    this.modalInputManual.open().then();
  }
}
